<template>
  <div id="main-header" class="sticky-navigation">
    <BContainer ref="real_estate_header" class="real_estate_header">
      <BRow class="no-gutters justify-content-center">
        <BCol lg="10" md="10" sm="12">
          <div class="">
            <img alt="Shadow Diplomats: Meet 15 controversial honorary consuls" src="https://media.icij.org/uploads/2022/11/Shadow-Diplomats-project-logo-background.jpg" />
          </div>
        </BCol>
        <BCol lg="6" md="10" sm="12">
          <h1 class="app_title text-center">{{ $t("appContent.title") }}</h1>
          <h2 class="app_title_sub text-center">{{ $t("appContent.subtitle") }}</h2>
        </BCol>
      </BRow>
      <BRow class="no-gutters justify-content-center py-3">
        <BCol lg="6" md="8" sm="12">
          <div class="text-center app_description">
            <span>{{ $t("appContent.excerpt") }}</span>
          </div>
        </BCol>
      </BRow>
      <SocialShare :layout="`home`" :title="$t('appContent.social_all')" share-link="https://www.icij.org/investigations/shadow-diplomats/controversial-honorary-consuls-profiles/"/>
    </BContainer>
  </div>
</template>

<script>
    import SocialShare from '@/components/SocialShare';

export default {
  name: "AppHeader",
  components: {
    SocialShare
  },
  mounted() {},
};
</script>

<style lang="scss">
.sticky-navigation {
  padding: 80px 0 15px 0;
  z-index: 99;

  img {
    width: 100%;
    min-height: 50vh;
    object-fit: cover;
  }

  .logo {
    display: flex;
    width: 175px;
    height: 175px;
    background: #fff;
    border-radius: 50%;
    align-items: center;
    justify-content: center;

    img {
      width: auto;
      height: 80%;
    }
  }
}
.text-red{
  color: var(--app-color-black);
}

</style>
